/**
 * HTTP adreslerini HTTPS yaparak "Güvenli değil" / karma içerik uyarısını önler.
 * Veritabanında eski http:// URL'leri olsa bile sayfada https ile yüklenir.
 */
export function ensureHttps(url: string | undefined | null): string {
  if (!url || typeof url !== 'string') return '';
  if (url.startsWith('http://')) return url.replace('http://', 'https://');
  return url;
}
